import { render, staticRenderFns } from "./FormImagemProductComponent.vue?vue&type=template&id=3c4b3306&scoped=true"
import script from "./FormImagemProductComponent.vue?vue&type=script&lang=js"
export * from "./FormImagemProductComponent.vue?vue&type=script&lang=js"
import style0 from "./FormImagemProductComponent.vue?vue&type=style&index=0&id=3c4b3306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b3306",
  null
  
)

export default component.exports